<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <v-data-table :url="url" :headers="headers" :items="complaints" :pagination.sync="pagination"
            :total-items="totalItems" :rows-per-page-items="[5, 10, 15, 25, 100]" :loading="loading">
            <template v-slot:items="props">
                <!-- <tr @click="expandTable(props)"> -->
                <!-- <tr @click="showDetails(props.item.description, props.item.id)"> -->
                <!-- <td class="text-xs-center">{{ props.item.id }}</td> -->
                <tr
                    :class="[$store.state.user.roles[0].name != 'Goverment' ? '' : props.item.complaint_status == 'Not Treated' ? 'not-treated' : props.item.complaint_status == 'Treated' ? 'treated' : 'partially-treated']">
                    <td class="text-xs-center">{{ props.index + 1 }}</td>
                    <td class="text-xs-center">
                        {{ props.item.booking_id }}
                    </td>
                    <td class="text-xs-center">
                        {{ props.item.datetime ? moment(props.item.datetime).format("DD-MM-YYYY - HH:mm") : "-" }}
                    </td>
                    <td class="text-xs-center">
                        {{ props.item.first_complaint_created_at ?
                            moment(props.item.first_complaint_created_at).format("DD-MM-YYYY - HH:mm") : "-" }}
                    </td>
                    <td class="text-xs-center">
                        {{ props.item.first_category }}
                    </td>
                    <td class="text-xs-center">
                        {{ props.item.count }}
                    </td>
                    <!-- <td class="text-xs-center"> -->
                    <!-- <span style="cursor: pointer">{{ -->
                    <!-- // ellipsify(props.item.description) -->
                    <!-- // }}</span> -->
                    <!-- </td> -->

                    <!-- <td class="text-xs-center"> -->
                    <!-- {{ moment(props.item.created_at).format("YYYY-MM-DD HH:ss") }} -->
                    <!-- </td> -->
                    <td class="text-xs-center">
                        <v-icon @click="bookingProfile(props.item)">info</v-icon>
                        <v-icon v-if="!readonly" @click="complaintsCategory(props.item)">edit</v-icon>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <v-dialog v-model="categoryDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline"> {{ $t("drivers.captainComplaints.categoryHeading") }} </span>
                </v-card-title>
                <v-card-text>
                    <div v-for="option in complaintCategories" :key="option.id" class="radio-option">
                        <input type="radio" :value="option.id" v-model="returnComplaintCategory" :id="option.id"
                            class="radio-input" />
                        <label :for="option.id" class="radio-label">{{ option.name }}</label>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" flat @click="closeDialog">{{ $t("common.close") }}</v-btn>
                    <v-btn color="primary" :loading="loading" flat @click="submitCategory">{{ $t("common.submit") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LoadingComponent from "@/components/LoadingComponent";

export default {
    name: "CaptainComplaints",
    components: { LoadingComponent },
    props: {
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            categoryDialog: false,
            totalItems: 0,
            complaints: [],
            complaintCategories: [],
            returnComplaintCategory: null,
            selectedComplaint: null,
            url: `captain/${this.$route.params.id}/complaint`,
            pagination: {
                sortBy: "id",
                rowsPerPage: 100,
            },
        }
    },
    computed: {
        headers() {
            return [
                { text: "#", value: "id", sortable: false, align: "center" },
                {
                    text: this.$t("drivers.captainComplaints.bookingId"),
                    value: "booking_id",
                    sortable: false,
                    align: "center",
                },
                {
                    text: this.$t("drivers.captainComplaints.bookingTime"),
                    value: "datetime",
                    sortable: false,
                    align: "center",
                },
                {
                    text: this.$t("drivers.captainComplaints.creationTime"),
                    value: "first_complaint_created_at",
                    sortable: false,
                    align: "center",
                },
                {
                    text: this.$t("drivers.captainComplaints.category"),
                    value: "first_category",
                    sortable: false,
                    align: "center",
                },
                {
                    text: this.$t("drivers.captainComplaints.count"),
                    value: "count",
                    sortable: false,
                    align: "center",
                }
            ];
        },
    },
    watch: {

        pagination: {
            handler() {
                this.getData();
            },
            deep: true,
        },
    },
    methods: {
        bookingProfile(item) {
            if (item.booking_id)
                window.open(`/rides/${item.booking_id}`, "_blank");
            else
                this.showDetails({ ...item, id: item.first_complaint_id }, item.first_complaint_id);
        },
        showDetails(complaint, id) {
            const audioPromise = this.axios.get(`complaint/${id}/audio`);
            const commentPromise = this.axios.get(`complaint_comments/${id}/get_comments`);
            const infoPromise = this.axios.get(`complaint-details/${id}`);
            Promise.allSettled([audioPromise, commentPromise, infoPromise]).then(([audios, comments, info]) => {
                if (info.status === "fulfilled" && info.value.data.data)
                    Object.assign(complaint, info.value.data.data);
                complaint.audios = audios.value.data.data;
                complaint.comments = comments.value.data.data;
                complaint.comments.forEach(comment => {
                    comment.audios = comment.audios.map((item) => {
                        return {
                            item: item,
                            loading: false,
                            urlObject: ''
                        }
                    });
                });
                this.$complaintDialog({
                    complaint: complaint,
                    hideCancel: true,
                    fileUpload: this.$t("drivers.captainComplaints.soundFiles"),
                    list: audios.value.data.data,
                    additionalData: {
                        id: id
                    }
                })
            });
        },

        complaintsCategory(item) {

            this.loading = true;
            this.selectedComplaint = item;
            this.$store
                .dispatch("fetchComplaintCategories")
                .then((data) => {
                    this.complaintCategories = data;
                    this.categoryDialog = true;
                    this.loading = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });

        },
        getData() {
            this.loading = true;
            const params = new URLSearchParams();

            params.append("perPage", String(this.pagination.rowsPerPage));
            params.append("page", this.pagination.page);

            this.axios
                .get(`captain/${this.$route.params.id}/complaint`, { params })
                .then((res) => {
                    console.log("data");
                    this.complaints = res.data.data.data;
                    console.log(this.data);
                    this.pagination.rowsPerPage = Number(res.data.data.per_page);
                    this.totalItems = res.data.data.total;

                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err.message);
                    this.loading = false;
                });
        },
        submitCategory() {
            if (!this.returnComplaintCategory) {
                window.getApp.$emit("SHOW_TOAST", this.$t("drivers.captainComplaints.chooseCategory"), "red");

                return;
            }

            this.loading = true;
            let url = "";
            let params = null;
            if (this.selectedComplaint.booking_id) {
                url = "complaint/category";
                params = {
                    category_id: this.returnComplaintCategory,
                    booking_id: this.selectedComplaint.booking_id
                };
            } else if (this.selectedComplaint.first_complaint_id) {
                url = "complaint-no-booking/category";
                params = {
                    category_id: this.returnComplaintCategory,
                    id: this.selectedComplaint.first_complaint_id
                };
            } else {
                return;
            }
            this.axios
                .post(url, params)
                .then((res) => {
                    this.loading = false;
                    this.closeDialog();
                    this.getData()
                })
                .catch((err) => {
                    console.log(err.message);
                    this.loading = false;
                });
        },
        closeDialog() {
            this.categoryDialog = false;
            this.selectedComplaint = null;
            this.returnComplaintCategory = false;
        }
    }
}
</script>

<style scoped>
.radio-option {
    padding-left: 30px;
    display: flex;
    align-items: center;
    margin: 10px 0;
    font-family: 'Poppins';
}

.radio-input {
    margin-right: 10px;
    cursor: pointer;
    accent-color: #4caf50;
    /* Change color of the radio button in modern browsers */
}

.radio-label {
    font-size: 16px;
    cursor: pointer;
}
</style>